import { Fragment } from 'react';
import useResult from '../../application/bloc/useResult';
import useBlocker from '../../application/hooks/useBlocker';
import useFooter from '../../application/hooks/useFooter';

import {
  Popup,
  Skeleton,
  SimpleItem,
  Spacer,
  DetailItemA,
  HeadTitle,
  TheSliderFilterBottomsheet,
  TheFooter,
  BridgeModal,
  Button,
  SimpleCard,
  Tsmbd16,
  Tmd16,
  Divider,
} from 'oui';
import {
  BannerBox,
  DefaultBox,
  FlexBox,
  FloatingBox,
  ListWithGap,
  SegmentBox,
} from '../etc/LBox/LBox';

import moment from 'moment/moment';
import EmptyResult from '../etc/EmptyResult/EmptyResult';
import Banner from '../dataDisplay/Banner/Banner';
import { useGetTime } from '../../application/helper/resultExpireTimer';
import Rolling from '../component/Rolling/Rolling';

const Result = () => {
  const {
    alertContent,
    setShowAlert,
    showAlert,
    shouldBlock,
    todayLoanList,
    navigateDetail,
    confirmFilter,
    changeSort,
    sortingItems,
    sortValue,
    categoryItems,
    categoryValues,
    changeCategories,
    openFilter,
    closeFilter,
    filterValue,
    isOpenFilter,
    filteredList,
    hasBestList,
    hasAllList,
    hasCancelList,
    hasRejectList,
    monthlyBannerContent,
    navigateDA,
    media,
    toDayRemainTime,
    before,
    sendBeaconClkBtnRate,
    sendBeaconClkBtnLimit,
    sendBeaconClkBtnFilter,
    sendBeaconClkBtnEbmpOutlink,
    isBridgeModal,
    onClickNaviButton,
    isLoading,
    custNm,
    maxAmount,
    hasBannerList,
    bannerList,
    beacon,
  } = useResult();

  const remainTime = useGetTime({
    hour: toDayRemainTime?.[0] ?? 0,
    minute: toDayRemainTime?.[1] ?? 0,
    second: toDayRemainTime?.[2] ?? 0,
  });

  const { navigateOvertake, navigateOvertakePrivacy, navigateTestPage } =
    useFooter();

  useBlocker((tx: any) => {
    if (tx.action === 'POP' && before.before !== 'entry') {
      setShowAlert(true);
    } else {
      tx.retry();
    }
  }, shouldBlock);

  const handleClickBestProduct = (val: number) => {
    beacon.sendIssueCatch({
      events: { subEventName: 'detail' },
      properties: {
        type: 'best',
        requestSeq: todayLoanList?.bestList[val].requestSeq ?? 0,
        preRequestDtlNo: todayLoanList?.bestList[val].preRequestDtlNo,
      },
    });
    navigateDetail(
      todayLoanList?.bestList[val].requestSeq,
      todayLoanList?.bestList[val].preRequestDtlNo,
    );
  };

  const handleClickAllProduct = (val: number) => {
    beacon.sendIssueCatch({
      events: { subEventName: 'detail' },
      properties: {
        type: 'all',
        requestSeq: filteredList[val]?.requestSeq ?? 0,
        preRequestDtlNo: filteredList[val]?.preRequestDtlNo,
      },
    });
    navigateDetail(
      filteredList[val]?.requestSeq,
      filteredList[val]?.preRequestDtlNo,
    );
  };

  const handleConfirmFilter = (e: any, value: any) => {
    confirmFilter(value);
  };
  const handleClickTab = (idx: number) => {
    if (idx === 0) {
      sendBeaconClkBtnLimit('한도순');
    } else if (idx === 1) {
      sendBeaconClkBtnRate('금리순');
    }
    changeSort(sortingItems[idx]?.value);
  };

  const handleClickFilterBtn = (e: any) => {
    sendBeaconClkBtnFilter(e.target.innerHTML);
    openFilter();
  };
  const handleCloseFilterBottomSheet = () => {
    closeFilter();
  };

  const getPreReqTime =
    moment(
      todayLoanList?.preRequestInfoData?.regDate,
      'YYYY.MM.DD HH:mm:ss',
    ).format('YYYY.MM.DD HH:mm') !== 'Invalid date'
      ? moment(
          todayLoanList?.preRequestInfoData?.regDate,
          'YYYY.MM.DD HH:mm:ss',
        ).format('YYYY.MM.DD HH:mm')
      : '0000.00.00 00:00';

  const handleClickNoResultBtn = () => {
    sendBeaconClkBtnEbmpOutlink('다른 대출 상품 보기');
    onClickNaviButton();
  };

  return (
    <>
      {isLoading ? (
        <Skeleton type={'c'} />
      ) : !hasAllList && !hasCancelList && !hasRejectList ? (
        <>
          <EmptyResult
            getPreReqTime={getPreReqTime}
            onClickMainBtn={handleClickNoResultBtn}
          />
        </>
      ) : !hasAllList && hasCancelList && !hasRejectList ? (
        <>
          <HeadTitle
            textTitle={'오늘 신청 가능한 상품을\n' + '모두 취소했어요'}
            subTitle={'취소한 대출은 내일 다시 신청 가능해요'}
          />
          <DefaultBox>
            {todayLoanList.cancelList.map((item: any, index: number) => {
              return (
                <>
                  <Spacer size={'md'} />
                  <SimpleItem
                    key={item.key + index + 'cancelList'}
                    state={'disabled'}
                    avatar={{
                      source: item.logoImgUrl,
                      alt: item.companyNm,
                      size: 'md',
                    }}
                    headerText={item.companyNm}
                    subheaderText={item.productNm}
                  />
                  <Spacer size={'md'} />
                </>
              );
            })}
          </DefaultBox>
          <TheFooter
            type={'a'}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
            onClickTest={navigateTestPage}
          />
          <Spacer size="lg"></Spacer>
          <FloatingBox status={false}>
            <Button
              flexible={true}
              configuration={'contained'}
              onClick={handleClickNoResultBtn}
            >
              다른 대출 상품 보기
            </Button>
          </FloatingBox>
        </>
      ) : (
        <>
          {/*{monthlyBannerContent && (*/}
          {/*  <DefaultBox>*/}
          {/*    <Banner*/}
          {/*      message={monthlyBannerContent.message}*/}
          {/*      onClick={() => monthlyBannerContent.handler()}*/}
          {/*    />*/}
          {/*  </DefaultBox>*/}
          {/*)}*/}

          {hasBestList && (
            <>
              <HeadTitle
                textTitle={`${
                  custNm || '회원'
                }님은 최대<br/>${maxAmount}을 빌릴 수 있어요`}
                subTitle={toDayRemainTime ? `유효시간 ${remainTime}` : ''}
                subTitlePos="top"
                color="purple_blue"
              />
              <ListWithGap>
                {todayLoanList?.bestList.map((item: any, index: number) => {
                  return (
                    <SimpleCard
                      key={`${index}${item.headerText}bestList`}
                      state={'enabled'}
                      subTitle={
                        item.state === 'interest' ? '최저 금리' : '최고 한도'
                      }
                      headerText={
                        item.state === 'interest'
                          ? item.interestRate + '%'
                          : item.amountText
                      }
                      subheaderText={item.productNm}
                      avatar={{ source: item.logoImgUrl, alt: 'logo' }}
                      btnText="자세히 보기"
                      onClickSimpleCard={() => handleClickBestProduct(index)}
                    />
                  );
                })}
              </ListWithGap>
            </>
          )}

          {hasBannerList && (
            <BannerBox>
              <Rolling
                items={bannerList}
                onClickItem={(idx) => {
                  bannerList[idx].navigate();
                  bannerList[idx].beacon.click();
                }}
                onChangeItem={(idx) => {
                  bannerList[idx].beacon.view();
                }}
              />
            </BannerBox>
          )}

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              padding: '0 20px',
              margin: ' 20px 0',
            }}
          >
            {categoryItems.map(({ category }) => {
              const isSelected = categoryValues.includes(category);

              return (
                <div
                  key={category}
                  style={{
                    padding: '6px',
                    backgroundColor: isSelected ? '#696969' : '#F1F5F9',
                    color: isSelected ? '#F1F5F9' : '#696969',
                    fontSize: '14px',
                    letterSpacing: '-0.3px',
                    borderRadius: '4px',
                  }}
                  onClick={() => changeCategories(category)}
                >
                  #{category}
                </div>
              );
            })}
          </div>

          {filteredList?.length > 0 && (
            <>
              <FlexBox
                padding="8px 20px"
                justify="space-between"
                alignItems="center"
              >
                <Tsmbd16 text="모든 대출 상품" color="#363636" />
                <SegmentBox>
                  {sortingItems.map((item, idx) => {
                    return (
                      <Fragment key={idx}>
                        {idx !== 0 && <Tmd16 text="|" color="#b5b5b5" />}
                        <span onClick={() => handleClickTab(idx)}>
                          <Tmd16
                            text={item.label}
                            color={
                              sortValue === item.value ? '#5950FF' : '#696969'
                            }
                          />
                        </span>
                      </Fragment>
                    );
                  })}
                </SegmentBox>
              </FlexBox>

              {filteredList?.map((item: any, idx: number) => {
                return (
                  <DetailItemA
                    key={item.preRequestDtlNo}
                    textTitle={item.companyNm}
                    subTitle={item.productNm}
                    avatar={{
                      source: item.logoImgUrl,
                      alt: item.companyNm,
                    }}
                    eventChip={item.eventChip}
                    valueA={item.interestRate + '%'}
                    valueB={item.limitValue}
                    eventText={item.benefitText}
                    onClickDetailItemA={() => handleClickAllProduct(idx)}
                    divider={idx < filteredList.length - 1}
                  />
                );
              })}
            </>
          )}

          {hasCancelList && (
            <>
              <Divider type={'contents'} />
              <HeadTitle textTitle={'취소한 대출 상품'} />
              <DefaultBox>
                {todayLoanList.cancelList.map((item: any, index: number) => {
                  return (
                    <>
                      {index > 0 && <Spacer size={'md'} />}
                      <SimpleItem
                        key={item.key + index + 'cancelList'}
                        state={'disabled'}
                        avatar={{
                          source: item.logoImgUrl,
                          alt: item.companyNm,
                          size: 'md',
                        }}
                        headerText={item.companyNm}
                        subheaderText={item.productNm}
                      />
                    </>
                  );
                })}
              </DefaultBox>
            </>
          )}

          {hasRejectList && (
            <>
              <Divider type={'contents'} />
              <HeadTitle textTitle={'미승인 대출 상품'} />
              <DefaultBox>
                {todayLoanList.rejectList.map((item: any, index: number) => {
                  return (
                    <>
                      {index > 0 && <Spacer size={'md'} />}
                      <SimpleItem
                        key={item.key + index + 'rejectList'}
                        state={'disabled'}
                        avatar={{
                          source: item.logoImgUrl,
                          alt: item.companyNm,
                          size: 'md',
                        }}
                        headerText={item.companyNm}
                        subheaderText={item.productNm}
                      />
                    </>
                  );
                })}
              </DefaultBox>
            </>
          )}
          <TheFooter
            type={'a'}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
            onClickTest={navigateTestPage}
          />
        </>
      )}

      <TheSliderFilterBottomsheet
        defaultValue={filterValue}
        onClose={handleCloseFilterBottomSheet}
        onConfirm={handleConfirmFilter}
        isSliderFilterBottomsheetOpen={isOpenFilter}
        buttonText={'확인'}
      />

      <Popup
        title={alertContent.message}
        isPopupOpen={showAlert}
        confirmBtn={{
          text: alertContent.confirmText,
          onClick: alertContent.handleClickConfirm,
        }}
        cancelBtn={
          alertContent.cancelText && alertContent.handleClickCancel
            ? {
                text: alertContent.cancelText,
                onClick: alertContent.handleClickCancel,
              }
            : undefined
        }
      />

      <BridgeModal
        isBridgeModalOpen={isBridgeModal}
        message={'대출비교서비스에서 금융상품으로\n 이동 중이에요'}
        timeout={2000}
        onDone={() => navigateDA(media)}
      />
    </>
  );
};

export default Result;
